import { createContext, ReactNode, useContext } from 'react'
import { SearchParameters, useIsFitterSchedulingMode, useIsPartnerPortalNeoSchedulingMode, useSearchParameters } from '../../../../hooks'

interface Props {
  children: ReactNode
  isConfigurationReadOnly?: boolean
}

const context = createContext(false)
const { Provider } = context

const IsConfigurationReadOnlyProvider = ({ children, isConfigurationReadOnly }: Props) => {
  const isFitterSchedulingMode = useIsFitterSchedulingMode()
  const isPartnerPortalNeoSchedulingMode = useIsPartnerPortalNeoSchedulingMode()
  const searchParams = useSearchParameters()
  const hasResourceIdParam = Boolean(searchParams[SearchParameters.RESOURCE_ID])
  // Partner portal neo mode should NOT be read-only even if resource_id is present
  const isReadOnly = Boolean(isConfigurationReadOnly || isFitterSchedulingMode || (hasResourceIdParam && !isPartnerPortalNeoSchedulingMode))

  return <Provider value={isReadOnly}>{children}</Provider>
}

const useIsConfigurationReadOnly = () => useContext(context)

export { IsConfigurationReadOnlyProvider, useIsConfigurationReadOnly }
